module.exports = __webpack_public_path__ + "static/media/sainsburys.2074e858.svg";